<template>
  <div class="source d-flex align-center justify-center">
    <div class="content d-flex f-column align-center">
      <h3>猪肉区块链溯源</h3>
      <p>
        猪肉区块链溯源平台采用区块链溯源技术，统一对生猪养殖、生猪采购、产地检疫、屠宰检疫、
      </p>
      <p>屠宰加工、物流运输、猪肉销售等环节进行区块链存储，实现溯源信息安全可靠、不可篡改</p>
      <div class="main d-flex">
        <div class="main-left">
          <div class="list">
            <div
              class="item d-flex align-center justify-center"
              :class="{ active: currentIndex === index }"
              v-for="(item, index) in list"
              :key="index"
              @click="handleClick(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="main-right d-flex align-center justify-center">
          <el-image class="image" :src="imgList[currentIndex].url"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      list: [
        { title: '养殖环节' },
        { title: '产地检疫' },
        { title: '屠宰检疫' },
        { title: '肉品检疫' },
        { title: '物流运输' },
        { title: '销售环节' }
      ],
      imgList: [
        { url: require('@/assets/images/source_01.png') },
        { url: require('@/assets/images/source_02.png') },
        { url: require('@/assets/images/source_03.png') },
        { url: require('@/assets/images/source_04.png') },
        { url: require('@/assets/images/source_05.png') },
        { url: require('@/assets/images/source_06.png') }
      ]
    }
  },
  methods: {
    handleClick(item, index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.source {
  .content {
    h3 {
      font-size: 0.375rem;
      padding: 1.25rem 0 0.375rem;
    }
    p {
      line-height: 0.375rem;
      font-size: 0.2rem;
      color: #666;
    }
    .main {
      padding-top: 0.825rem;
      padding-bottom: 1.25rem;
      &-left {
        margin-right: 1.125rem;
        .list {
          .item {
            position: relative;
            width: 3.75rem;
            height: 1.375rem;
            font-weight: 600;
            font-size: 0.3rem;
            color: #666;
            cursor: pointer;
            user-select: none;
            &:nth-of-type(odd) {
              background-color: #f9fafe;
            }
            &.active {
              color: #2373f0;
              &::before {
                content: '';
                position: absolute;
                left: 0;
                width: 0.075rem;
                height: 100%;
                background-color: #2373f0;
              }
            }
          }
        }
      }
      &-right {
        width: 5.25rem;
        height: 8.25rem;
        background: url('../../../assets/images/source_bg.png') no-repeat;
        background-size: 5.25rem 8.25rem;
        .image {
          display: block;
          width: 4.025rem;
          height: 7.175rem;
        }
      }
    }
  }
}
</style>
